import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddTimesheet, CommonWebService, DefaultTimsheetList, HttpResponse, ProjectListDetail, ProjectListTs, SearchProjectForm, TaskList, TaskListTs, TimesheetOverviewApiData, UserHttpService } from '../public-api';

@Injectable({
    providedIn: 'root'
})
export class TimesheetService {

    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userSessionService: UserHttpService
    ) { }


    public timesheetActivityList(): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);

        return this.http.post<HttpResponse<any>>("timesheet/timeSheetActivityList", formData);
    }

    public addTimesheet(body: AddTimesheet, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);

        formData.append("project_track_id", body.project_track_id ? body.project_track_id : "");
        formData.append("task_track_id", body.task_track_id ? body.task_track_id : "");
        formData.append("activity_track_id", body.task_track_id ? body.task_track_id : "");
        formData.append("hours", this.formatTimesheetHourMinute(body.hours));
        formData.append("minutes", this.formatTimesheetHourMinute(body.minutes));
        formData.append("timesheet_date", body.timesheet_date ? this.commonService.changeDateFormat(body.timesheet_date as Date) : "");
        formData.append("worktype", body.worktype ? body.worktype : "");
        formData.append("work_description", body.work_description ? body.work_description : "");
        // formData.append("time_range", body.fromTime && body.toTime ? `${body.fromTime}-${body.toTime}` : "");

        if (isEdit && body.timesheet_id) {
            formData.append("timesheet_id", body.timesheet_id ? body.timesheet_id : "");
        };

        return this.http.post<HttpResponse<any>>("timesheet/createTimesheet", formData);
    }

    /** Form values are numbers (0–23 / 0–59); 0 must send as "00", not omitted (falsy bug). */
    private formatTimesheetHourMinute(
        value: string | number | null | undefined
    ): string {
        if (value === null || value === undefined || value === "") {
            return "";
        }
        const n = Number(value);
        if (Number.isNaN(n)) {
            return String(value);
        }
        return Math.trunc(n).toString().padStart(2, "0");
    }

    public taskList(projectId: string): Observable<HttpResponse<TaskListTs[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("project_id", projectId ? projectId : "")
        return this.http.post<HttpResponse<TaskListTs[]>>('timesheet/taskListbyProject', formData);
    }

    //project list
    public getTimesheetProjectList(): Observable<HttpResponse<ProjectListTs[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        return this.http.post<HttpResponse<ProjectListTs[]>>("timesheet/projectListForTs", formData);
    }

    //default timesheet list
    public defaultTimesheetList(from_date: Date | string, to_date: Date | string, project_id?: string): Observable<HttpResponse<DefaultTimsheetList[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("from_date", from_date ? this.commonService.changeDateFormat(from_date as Date) : "");
        formData.append("to_date", to_date ? this.commonService.changeDateFormat(to_date as Date) : "");

        if (project_id) {
            formData.append("project_id", project_id ? project_id : "");
        }
        return this.http.post<HttpResponse<DefaultTimsheetList[]>>("timesheet/timesheet", formData);
    }


    //timesheet detail
    public getTimesheetDetail(timeId: string): Observable<HttpResponse<DefaultTimsheetList[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("time_id", timeId ? timeId : "");
        return this.http.post<HttpResponse<DefaultTimsheetList[]>>("timesheet/myTimeDetail", formData);
    }

    /** Fetches the timesheet overview for all team members within a date range. */
    public timesheetOverviewList(from_date: string, to_date: string): Observable<HttpResponse<TimesheetOverviewApiData>> {
        const formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("from_date", from_date);
        formData.append("to_date", to_date);
        return this.http.post<HttpResponse<TimesheetOverviewApiData>>("timesheet/timesheetList", formData);
    }

    /** Deletes a timesheet row. POST `timesheet/deleteTimeSheet` with `time_id` (same id as list `tmid`). */
    public deleteTimesheet(time_id: string): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("time_id", time_id ? time_id : "");
        return this.http.post<HttpResponse<any>>("timesheet/deleteTimeSheet", formData);
    }

}